import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import ListSubheader from "@mui/material/ListSubheader";
import IconButton from "@mui/material/IconButton";
import apiClient from "../../api/apiClient";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import EditOutlined from "@mui/icons-material/EditOutlined";
import { handleErrors } from "../../modules/handleErrors";
import { toast } from "react-toastify";
import WarningModal from "../../modals/WarningModal";

const DELETE_WARNING_MESSAGES = {
  category:
    "Are you sure you want to delete this category? All related subcategories will also be removed. This action cannot be undone.",
  subcategory:
    "Are you sure you want to delete this subcategory? This action cannot be undone.",
  subsubcategory:
    "Are you sure you want to delete this sub-subcategory? This action cannot be undone.",
};

const CategoryActionIcons = ({ onDelete, onEdit }) => (
  <div className="d-flex align-items-center flex-shrink-0 pe-2">
    <IconButton
      size="small"
      aria-label="Delete"
      onClick={(e) => {
        e.stopPropagation();
        onDelete();
      }}
      sx={{
        color: "#dc3545",
        "&:hover": { backgroundColor: "rgba(220, 53, 69, 0.08)" },
      }}
    >
      <DeleteOutline fontSize="small" />
    </IconButton>
    <IconButton
      size="small"
      aria-label="Edit"
      onClick={(e) => {
        e.stopPropagation();
        onEdit();
      }}
      sx={{
        color: "#1976d2",
        "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.08)" },
      }}
    >
      <EditOutlined fontSize="small" />
    </IconButton>
  </div>
);

const CategoriesListedit = ({
  setmockpupData,
  seteditItem,
  fetchcategories,
  categoriesdata,
  fetchcategoriesdata,
  setcategoryId,
  seteditmodle,
  setsubcategoryId,
  setSubsubcategory,
  setsubsubcategoryId,
}) => {
  const [open, setOpen] = useState({});
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const [deleteSubmitting, setDeleteSubmitting] = useState(false);

  const [categoryloader, setcategoryloader] = useState(false);

  const [categoriesid, setcategoriesid] = useState(null);

  const handleClick = (id) => {
    setOpen((prevOpen) => ({ ...prevOpen, [id]: !prevOpen[id] }));
  };

  const openDeleteWarning = (type, id, name) => {
    setPendingDelete({ type, id, name });
    setShowDeleteWarning(true);
  };

  const closeDeleteWarning = () => {
    if (deleteSubmitting) return;
    setShowDeleteWarning(false);
    setPendingDelete(null);
  };

  const Deletecategories = async (id) => {
    const result = await apiClient.delete(`/categories/${id}/`);
    if (!result.ok) {
      handleErrors(result.data);
      return false;
    }
    toast.success("Category deleted successfully");
    fetchcategories();
    fetchcategoriesdata();
    return true;
  };

  const DeleteSubcategories = async (id) => {
    const result = await apiClient.delete(`/subcategory/${id}/`);
    if (!result.ok) {
      handleErrors(result.data);
      return false;
    }
    toast.success("Subcategory deleted successfully");
    fetchcategoriesdata();
    return true;
  };

  const DeleteSubsubcategories = async (id) => {
    const result = await apiClient.delete(`/subsubcategories/${id}/`);
    if (!result.ok) {
      handleErrors(result.data);
      return false;
    }
    toast.success("Sub-subcategory deleted successfully");
    fetchcategoriesdata();
    return true;
  };

  const handleConfirmDelete = async () => {
    if (!pendingDelete?.id) return;

    setDeleteSubmitting(true);
    try {
      let success = false;

      if (pendingDelete.type === "category") {
        success = await Deletecategories(pendingDelete.id);
      } else if (pendingDelete.type === "subcategory") {
        success = await DeleteSubcategories(pendingDelete.id);
      } else if (pendingDelete.type === "subsubcategory") {
        success = await DeleteSubsubcategories(pendingDelete.id);
      }

      if (success) {
        setShowDeleteWarning(false);
        setPendingDelete(null);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to delete. Please try again.");
    } finally {
      setDeleteSubmitting(false);
    }
  };

  const deleteWarningText = pendingDelete
    ? pendingDelete.name
      ? `Are you sure you want to delete "${pendingDelete.name}"? This action cannot be undone.`
      : DELETE_WARNING_MESSAGES[pendingDelete.type]
    : "";

  return (
    <div>
      <List
        component="nav"
        subheader={
          <ListSubheader
            component="h2"
            id="nested-list-subheader"
            sx={{
              backgroundColor: "#000",
              borderRadius: "12px",
              color: "#fff",
              textAlign: "center",
              fontSize: "18px",
            }}
          >
            Categories
          </ListSubheader>
        }
      >
        {categoriesdata?.map((category, catIndex) => (
          <ListItem
            key={category.id}
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "0px",
              alignItems: "stretch",
              width: "100%",
            }}
          >
            <div className="d-flex align-items-center w-100">
              <ListItemButton
                onClick={() => handleClick(`cat-${catIndex}`)}
                sx={{ flex: 1, minWidth: 0 }}
              >
                <ListItemText primary={category.name} />
                {open[`cat-${catIndex}`] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <CategoryActionIcons
                onDelete={() =>
                  openDeleteWarning("category", category?.id, category?.name)
                }
                onEdit={() => {
                  setcategoryId(category?.id);
                  setsubcategoryId("");
                  setsubsubcategoryId && setsubsubcategoryId("");
                  seteditmodle(true);
                  seteditItem(category.name);
                }}
              />
            </div>
            <Collapse in={open[`cat-${catIndex}`]} timeout="auto" unmountOnExit>
              <List className="py-0 ms-3 ">
                {category.subcategories.map((subcategory) => (
                  <ListItem
                    key={subcategory.id}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0px",
                      alignItems: "stretch",
                      width: "100%",
                    }}
                    onClick={() => setcategoriesid(subcategory.id)}
                  >
                    <div className="d-flex align-items-center w-100">
                      <ListItemButton
                        onClick={() =>
                          handleClick(`sub-${catIndex}-${subcategory.id}`)
                        }
                        sx={{ flex: 1, minWidth: 0 }}
                      >
                        <ListItemText
                          primary={subcategory.name}
                          sx={{
                            padding: "3px",
                            color: "#6c6c6c",
                            fontSize: "14px",
                            lineHeight: "15px",
                          }}
                        />
                        {subcategory.subsubcategories &&
                          subcategory.subsubcategories.length > 0 &&
                          (open[`sub-${catIndex}-${subcategory.id}`] ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          ))}
                      </ListItemButton>
                      <CategoryActionIcons
                        onDelete={() =>
                          openDeleteWarning(
                            "subcategory",
                            subcategory.id,
                            subcategory.name
                          )
                        }
                        onEdit={() => {
                          setsubcategoryId(subcategory.id);
                          setcategoryId("");
                          setsubsubcategoryId && setsubsubcategoryId("");
                          seteditmodle(true);
                          seteditItem(subcategory.name);
                        }}
                      />
                    </div>

                    {/* Sub Sub Categories */}
                    {subcategory.subsubcategories &&
                      subcategory.subsubcategories.length > 0 && (
                        <Collapse
                          in={open[`sub-${catIndex}-${subcategory.id}`]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List className="py-0 ms-3">
                            {subcategory?.subsubcategories?.map(
                              (subsubcategory) => (
                                <ListItem
                                  key={subsubcategory.id}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: "0px",
                                    alignItems: "stretch",
                                    width: "100%",
                                  }}
                                >
                                  <div className="d-flex align-items-center w-100">
                                    <ListItemButton sx={{ flex: 1, minWidth: 0 }}>
                                      <ListItemText
                                        primary={subsubcategory.name}
                                        sx={{
                                          padding: "3px",
                                          color: "#999",
                                          fontSize: "12px",
                                          lineHeight: "13px",
                                          paddingLeft: "20px",
                                        }}
                                      />
                                    </ListItemButton>
                                    <CategoryActionIcons
                                      onDelete={() =>
                                        openDeleteWarning(
                                          "subsubcategory",
                                          subsubcategory.id,
                                          subsubcategory.name
                                        )
                                      }
                                      onEdit={() => {
                                        setsubsubcategoryId &&
                                          setsubsubcategoryId(
                                            subsubcategory.id
                                          );
                                        setsubcategoryId("");
                                        setcategoryId("");
                                        seteditmodle(true);
                                        seteditItem(subsubcategory.name);
                                      }}
                                    />
                                  </div>
                                </ListItem>
                              )
                            )}
                          </List>
                        </Collapse>
                      )}
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </ListItem>
        ))}
      </List>
      <WarningModal
        showModal={showDeleteWarning}
        modalClose={closeDeleteWarning}
        setConfirmClose={handleConfirmDelete}
        text={deleteWarningText}
        confirmDisabled={deleteSubmitting}
        confirmLabel={deleteSubmitting ? "Deleting..." : "Confirm"}
      />
    </div>
  );
};

export default CategoriesListedit;
